export default "__VITE_ASSET__3h74krWJ__"